import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

import MembershipModel from "views/Components/MembershipModel.jsx"
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlined from "@material-ui/icons/InfoOutlined";

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { Chart } from "react-google-charts";

import chartsStyle from "assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import axios from "axios";
import { API_ROOT } from 'api-config';

const troubleChartExplanation = "The trouble score is a way to determine the relative impact of a given insurance company " +
  "on the financial health of your practice. A high trouble score means the insurance company is relatively bad for the " +
  "financial health of your practice. A low trouble score means it is relatively good. The trouble score accounts for both " +
  "the percentage of revenue attributed to a given insurance and how the performance of that insurance compares to others " +
  "in your practice. Here's how it works: We use two key values to calculate the trouble score. First, we take the percentage " +
  "of revenue attributed to a certain insurance and square it. This accounts for the fact that a larger insurance has an " +
  "outsize influence on the financial health of your practice. For example, an insurer that accounts for 30% of your revenue " +
  "is more than ten times as important as an insurer that accounts for 3% of your revenue. We then take this number and multiply " +
  "it by the revenue skew. Basically, the revenue skew is how well the insurance performs compared to others in your practice. " +
  "(You can read more about this by mousing over or clicking on the 'revenue skew' column header in the table above.) This " +
  "gives us your raw trouble score value. To make the numbers easier to read, we normalize the values. Normalizing the values " +
  "means that all values are shown as relative values between 0 and 100."



class FinancialsAnalytics extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId;
    var allFinancials;
    if (props.userId) {
      userId = props.userId
    } else {
      userId = sessionStorage.getItem('userId')
    }
    if (props.allFinancials) {
      allFinancials = props.allFinancials
    }

    this.state = {
      userId: userId,
      allFinancials: allFinancials,
      normalizedRevenueSkew: [],
      normalizedRevenueSkewOptions: [],
      billedShare: [],
      revenueShare: [],
      patientShare: [],
      billedShareMembership: [],
      revenueShareMembership: [],
      patientShareMembership: [],
      membershipFinancials: '',
      compositeShare: [],
      newRevenue: 'n/a',
      increasedRevenue: 'n/a',
      increasedProfit: 'n/a',
      modeledFinancialsError: ''
    };
  }

  componentDidMount(){
    this._isMounted = true;
    this.generateCharts()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.allFinancials !== this.props.allFinancials) {
      this.generateCharts()
      this.getModeledFinancials()
    }
  }
  static getDerivedStateFromProps(nextProps, prevState){
    // Do the update only if allFinancials has not already been set
    // This allows it to be set once it is received from parent, but it also avoids a conflict if allFinancials is updated via a child
    if(nextProps.allFinancials!==prevState.allFinancials){
      return {
        allFinancials: nextProps.allFinancials
      };
    }
    else return null;
  }

  generateCharts() {
    this.generateRevenueSkewChart()
    this.generatePieCharts()
    this.generateCompositeShare()
  }

  generateRevenueSkewChart() {
    var i;
    var financials;
    var financialsArray;
    const skewStats = []
    for (i in this.state.allFinancials) {
      financials = this.state.allFinancials[i]
      if (financials['financialsStats']) {
        financialsArray = [financials['entity'], financials['financialsStats']['normalizedRevenueSkew']]
        skewStats.push(financialsArray)
      }
    }

    skewStats.sort(function(a,b){return a[1] < b[1]})
    this.setState({
      normalizedRevenueSkew: skewStats
    })
  }

  generatePieCharts() {

    const pieChartData = this.formatPieChartData(this.state.allFinancials)

    this.setState({
      billedShare: pieChartData.billedShare,
      revenueShare: pieChartData.revenueShare,
      patientShare: pieChartData.patientShare
    })

  }

  formatPieChartData(allFinancials) {
    var i;
    var financials;
    const billedShare = [];
    const revenueShare = [];
    const patientShare = [];
    for (i in allFinancials) {
      financials = allFinancials[i]
      if (financials['financialsStats']) {
        billedShare.push([financials['entity'], financials['financialsStats']['billedShare']])
        revenueShare.push([financials['entity'], financials['financialsStats']['revenueShare']])
        patientShare.push([financials['entity'], financials['financialsStats']['patientShare']])
      }
    }

    billedShare.unshift(['insurance', '% of bills'])
    revenueShare.unshift(['insurance', '% of revenue'])
    patientShare.unshift(['insurance', '% of patients'])

    const pieChartData = {}
    pieChartData.billedShare = billedShare
    pieChartData.revenueShare = revenueShare
    pieChartData.patientShare = patientShare

    return pieChartData
  }

  generateCompositeShare() {

    var i;
    var financials;
    const compositeShare = [];
    for (i in this.state.allFinancials) {
      financials = this.state.allFinancials[i]
      if (financials['financialsStats']) {
        compositeShare.push([financials['entity'], financials['financialsStats']['billedShare'], financials['financialsStats']['revenueShare'], financials['financialsStats']['patientShare']])
      }
    }

    compositeShare.unshift(['insurance', 'billed', 'revenue', 'patients'])

    this.setState({
      compositeShare: compositeShare
    })
  }

  getModeledFinancials() {
    axios.get(`${API_ROOT}/practiceSystem/membership/?userId=`+this.state.userId+`&returnAnalytics=true`, {headers: getApiHeaders()})
      .then(res => this.setModeledFinancials(res.data));
  }

  setModeledFinancials(newFinancials) {
    if (newFinancials['error']) {
      if (newFinancials['error'] !== this.state.modeledFinancialsError) {

        this.setState({
          modeledFinancialsError: newFinancials['error']
        }, alert(newFinancials['error']))
      }
    } else {
      this.setState({
        membershipFinancials: newFinancials['entities'],
        modeledFinancialsError: ''
      }, this.generateMembershipCharts)
      if (newFinancials.hasOwnProperty('totals')) {
        this.calculateMembershipStats(newFinancials)
      }
    }
  }

  generateMembershipCharts() {
    const pieChartData = this.formatPieChartData(this.state.membershipFinancials)

    this.setState({
      billedShareMembership: pieChartData.billedShare,
      revenueShareMembership: pieChartData.revenueShare,
      patientShareMembership: pieChartData.patientShare
    })
  }

  calculateMembershipStats(newFinancials) {
    const preMembershipRevenue = newFinancials['totalsPreMembership']['revenue']
    const postMembershipRevenue = newFinancials['totals']['revenue']
    const newRevenue = postMembershipRevenue - preMembershipRevenue
    const increasedRevenue = (newRevenue / preMembershipRevenue) * 100
    const preMembershipRevenueProfit = preMembershipRevenue * .25
    const increasedProfit = (newRevenue / preMembershipRevenueProfit) * 100
    this.setState({
      newRevenue: newRevenue.toFixed(2),
      increasedRevenue: increasedRevenue.toFixed(2),
      increasedProfit: increasedProfit.toFixed(2)
    })
  }

  render() {
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={5}>
            <Card>
              <CardBody>
                <MembershipModel
                  userId = {this.state.userId}
                  updateCharts = {this.getModeledFinancials.bind(this)}
                  allFinancials = {this.state.allFinancials}
                />

              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={7}>
            <Card>
              <CardHeader>
                membership stats
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    new revenue:
                  </GridItem>

                  <GridItem xs={12} sm={12} md={9}>
                    ${this.state.newRevenue}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={3}>
                    increased revenue:
                  </GridItem>

                  <GridItem xs={12} sm={12} md={9}>
                    {this.state.increasedRevenue}%
                  </GridItem>

                  <GridItem xs={12} sm={12} md={3}>
                    increased profit:
                  </GridItem>

                  <GridItem xs={12} sm={12} md={9}>
                    {this.state.increasedProfit}%
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <small>Increased profit estimate is based on dentist-owner salary and profit, and assumes pre-membership plan salary and profit is approximately 25% of total revenue.</small>
                  </GridItem>
                </GridContainer>

              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            Share of billed and revenue without membership program
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card>
              <CardBody>
                <Chart
                  chartType="PieChart"
                  loader={<div>Loading Chart</div>}
                  data={this.state.billedShare}
                  options={{
                    title: 'Share of billed',
                  }}
                  rootProps={{ 'data-testid': '1' }}
                />
              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={4}>
            <Card>
              <CardBody>
                <Chart
                  chartType="PieChart"
                  loader={<div>Loading Chart</div>}
                  data={this.state.revenueShare}
                  options={{
                    title: 'Share of revenue',
                  }}
                  rootProps={{ 'data-testid': '2' }}
                />
              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={4}>
            <Card>
              <CardBody>
                <Chart
                  chartType="PieChart"
                  loader={<div>Loading Chart</div>}
                  data={this.state.patientShare}
                  options={{
                    title: 'Share of patients',
                  }}
                  rootProps={{ 'data-testid': '3' }}
                />
              </CardBody>
            </Card>
          </GridItem>

          <GridContainer style={this.state.membershipFinancials === '' ? { display: 'none' } : {}}>
            <GridItem xs={12} sm={12} md={12}>
              Share of billed and revenue with membership program
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card>
                <CardBody>
                  <Chart
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={this.state.billedShareMembership}
                    options={{
                      title: 'Share of billed',
                    }}
                    rootProps={{ 'data-testid': '1' }}
                  />
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <Card>
                <CardBody>
                  <Chart
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={this.state.revenueShareMembership}
                    options={{
                      title: 'Share of revenue',
                    }}
                    rootProps={{ 'data-testid': '2' }}
                  />
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <Card>
                <CardBody>
                  <Chart
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={this.state.patientShareMembership}
                    options={{
                      title: 'Share of patients',
                    }}
                    rootProps={{ 'data-testid': '3' }}
                  />
                </CardBody>
              </Card>
            </GridItem>

          </GridContainer>
           <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardBody>
                <Tooltip title={troubleChartExplanation} placement="top-start">
                  <span>
                     <div>Trouble score - the higher the score for an insurance, the more of a burden it is on your practice.<InfoOutlined/></div>
                  </span>
                </Tooltip>
                Identify patients with higher-scoring insurance plans and prioritize moving them to a membership plan.
                <List dense={true}>
                  {this.state.normalizedRevenueSkew.map((skewData, idx) => (
                    <ListItem key={idx}>
                      <ListItemText
                        primary={skewData[0]}
                        secondary={'relative score: ' + (skewData[1]*100).toFixed(2)}
                      />
                    </ListItem>
                  ))}
                  <ListItem style={this.state.normalizedRevenueSkew.length === 0 ? {} : { display: 'none' }}>
                    <ListItemText
                      primary="Please enter insurance information to see trouble scores."
                    />
                  </ListItem>
                </List>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

      </div>
    );
  }
}

export default withStyles(chartsStyle)(FinancialsAnalytics);
